module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.ac154b4.eot";